import React from "react";
import ReactDOM from "react-dom/client";

// Prevent the browser from restoring scroll position on SPA navigation
if ("scrollRestoration" in history) history.scrollRestoration = "manual";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline caching + PWA installability (production only)
serviceWorkerRegistration.register();
